var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
/*
 * Returns a formatted string
 * @param {Date} the date object
 * @return {String} the date formatted
 */

var dateString = function dateString(date) {
  return "".concat(months[date.getMonth()], " ").concat(date.getDate(), ", ").concat(date.getFullYear());
};

export default dateString;
/*
 * Returns a string with the format MM DD YY - ex. Wed Oct 09
 * @param {Date} the date object
 * @return {String} the date formatted
 */

export var dayMonthDateShort = function dayMonthDateShort(date) {
  var dayOfWeek = days[date.getUTCDay()].slice(0, 3);
  var month = months[date.getUTCMonth()].slice(0, 3);
  var dateNumber = date.getUTCDate();
  return "".concat(dayOfWeek, " ").concat(month, " ").concat(dateNumber);
};
/*
 * Returns a string with the format MMM DD, YYYY - ex. September 16, 2019
 * @param {Date} the date object
 * @return {String} the date formatted
 */

export var monthDayYear = function monthDayYear(date) {
  var month = months[date.getUTCMonth()];
  var dateNumber = date.getUTCDate();
  return "".concat(month, " ").concat(dateNumber, ", ").concat(date.getFullYear());
};